import type { RuntimeConfig } from '@/app/runtime-config';
import { isRenderableAssetUrl } from '@/app/theme/brand-theme';
import { cn } from '@/lib/utils';

type Brand = RuntimeConfig['presentation']['brand'];

/**
 * The brand-pack logo. With a dark variant, both render and CSS picks one (`dark:`), so a theme
 * switch never flashes the wrong logo and the hidden one stays out of the accessibility tree.
 */
export function BrandLogo({
  brand,
  className,
  decorative = false,
}: {
  brand: Brand;
  className?: string;
  decorative?: boolean;
}) {
  if (!isRenderableAssetUrl(brand.logoUrl)) return null;
  const alt = decorative ? '' : (brand.logoAlt ?? brand.companyName ?? brand.productName);
  const dark = isRenderableAssetUrl(brand.logoDarkUrl) ? brand.logoDarkUrl : undefined;
  if (!dark) return <img src={brand.logoUrl} alt={alt} className={className} />;
  return (
    <>
      <img src={brand.logoUrl} alt={alt} className={cn(className, 'dark:hidden')} />
      <img src={dark} alt={alt} className={cn(className, 'hidden dark:block')} />
    </>
  );
}
